// src/components/Contact.tsx
import type React from "react"
import { useState } from "react"
import { Container, TextField, Button, Typography, Box } from "@mui/material"
import emailjs from "emailjs-com"
import { motion } from "framer-motion"

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(null);

    const serviceID = 'service_oby27i8'; 
    const templateID = 'template_z85xt0h';
    const publicKey = 'u2PMHLYnA_jh7aw69'; 

    try {
      await emailjs.send(serviceID, templateID, formData, publicKey);
      setStatus('Email sent successfully!');
      setFormData({ firstName: '', lastName: '', email: '', message: '' });
    } catch (error) {
      console.error("Failed to send email via EmailJS:", error);
      setStatus('Failed to send email. Please try again later.');
    }
  };

  return (
    <div style={{ backgroundColor: '#001f3f', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <Container maxWidth="sm" style={{ backgroundColor: 'beige', color: '#021526', padding: '40px', borderRadius: '8px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)' }}>
      <motion.div initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <Typography variant="h4" component="h1" gutterBottom style={{ color: "#001f3f", textAlign: "center" }}>
            Contact Me
          </Typography>
        </motion.div>

        <motion.form
          onSubmit={handleSubmit}
          noValidate
          autoComplete="off"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <Box mb={2}>
            <TextField
              label="First Name"
              variant="outlined"
              fullWidth
              required
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              InputLabelProps={{ style: { color: "#001f3f" } }}
              inputProps={{ style: { color: "#001f3f" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#001f3f",
                  },
                  "&:hover fieldset": {
                    borderColor: "#001f3f",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#001f3f",
                  },
                },
              }}
            />
          </Box>

          <Box mb={2}>
            <TextField
              label="Last Name"
              variant="outlined"
              fullWidth
              required
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              InputLabelProps={{ style: { color: "#001f3f" } }}
              inputProps={{ style: { color: "#001f3f" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#001f3f",
                  },
                  "&:hover fieldset": {
                    borderColor: "#001f3f",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#001f3f",
                  },
                },
              }}
            />
          </Box>

          <Box mb={2}>
            <TextField
              label="Email Address"
              variant="outlined"
              fullWidth
              required
              name="email"
              value={formData.email}
              onChange={handleChange}
              type="email"
              InputLabelProps={{ style: { color: "#001f3f" } }}
              inputProps={{ style: { color: "#001f3f" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#001f3f",
                  },
                  "&:hover fieldset": {
                    borderColor: "#001f3f",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#001f3f",
                  },
                },
              }}
            />
          </Box>

          <Box mb={3}>
            <TextField
              label="Message"
              variant="outlined"
              fullWidth
              required
              name="message"
              value={formData.message}
              onChange={handleChange}
              multiline
              rows={4}
              InputLabelProps={{ style: { color: "#001f3f" } }}
              inputProps={{ style: { color: "#001f3f" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#001f3f",
                  },
                  "&:hover fieldset": {
                    borderColor: "#001f3f",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#001f3f",
                  },
                },
              }}
            />
          </Box>

          <Button
            variant="contained"
            fullWidth
            type="submit"
            style={{ backgroundColor: "#001f3f", color: "white", fontWeight: "bold" }}
          >
            Submit
          </Button>

          {status && (
            <Typography variant="body1" align="center" color="secondary" style={{ marginTop: "10px" }}>
              {status}
            </Typography>
          )}
        </motion.form>
      </Container>
    </div>
  )
}

export default Contact

